// extracted by mini-css-extract-plugin
export default {"about-us":"About_about-us__iHbqq","about__img":"About_about__img__7ELXC","about__wrapper":"About_about__wrapper__9uh-3","about__description":"About_about__description__qtA9N"};